import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useReactiveVar } from '@apollo/client'

import { Dialog } from 'components'
import { activeProjectVar, showArchivedDialogVar, showArchivedGrowlVar } from 'modulesCommon/store'
import { useProject } from 'modules/ProjectEdit/serviceHooks'

import { TRouterParams } from 'shared/types'

import './ArchivedDialog.scss'

const ArchivedDialog = () => {
  const showArchivedDialog = useReactiveVar(showArchivedDialogVar)
  const activeProject = useReactiveVar(activeProjectVar)

  const { id } = useParams<TRouterParams>()
  const navigate = useNavigate()

  const { archiveProject, activateProject } = useProject(id)

  return (
    <Dialog
      visible={showArchivedDialog}
      title={`${activeProject.active ? 'Archive' : 'Activate'} Project`}
      hideCancel={false}
      classList="gh-project-edit__confirm archived-dialog"
      body={<span>Are you sure you want to {activeProject.active ? 'archive' : 'activate'} this project?</span>}
      onOk={
        activeProject.active
          ? {
            name: 'Archive',
            action: () =>
              archiveProject(id).then(() => {
                showArchivedDialogVar(false)
                navigate(-1)
                //TODO: Need to update growl container position
                setTimeout(() => showArchivedGrowlVar(true), 500)
              })
          }
          : {
            name: 'Activate',
            action: () =>
              activateProject(id).then(() => {
                showArchivedDialogVar(false)
                showArchivedGrowlVar(true)
              })
          }
      }
      onCancel={{
        name: 'Cancel',
        action: () => showArchivedDialogVar(false)
      }}
    />
  )
}

export default ArchivedDialog
